import { Patient } from "@/Common/Models/Patient/Patient";
import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

enum PatientBannerBottomLeftRegistryComponentId {
    LaunchOacisButton = 0
}

type PatientBannerBottomLeftRegistryProps = {
    patient: Patient;
};

class PatientBannerBottomLeftRegistry extends BaseComponentRegistry<PatientBannerBottomLeftRegistryComponentId, PatientBannerBottomLeftRegistryProps> {}

const PatientBannerBottomLeftRegistryView = createRegistryListView(() => PatientBannerBottomLeftRegistry.getInstance());

export {
    PatientBannerBottomLeftRegistry,
    PatientBannerBottomLeftRegistryComponentId,
    PatientBannerBottomLeftRegistryView
};

export type { PatientBannerBottomLeftRegistryProps };
